// extracted by mini-css-extract-plugin
export default {"container":"_e5127e2e","imageContainer":"_28f63689","image":"_607ca54e","content":"_a1f1da60","soldIcon":"_d6fd5d56","title":"_e8cf5769","buttonContainer":"_707074b8"};